import { useEffect, useState, VFC } from 'react'
import { PUBLISHED } from 'src/assets/images'
import { Logo, MenuIcon } from 'src/assets/svgs'
import { TEL_CONTACT } from 'src/data/common'
import { Link } from 'src/elements/Link'
import {
  orange,
  trueblack,
  truewhite,
  white,
  _telborder,
} from 'src/styles/colors'
import { fontWeightBold } from 'src/styles/font'
import { flexCenter } from 'src/styles/mixins'
import { TOP } from 'src/utils/routes'
import styled from 'styled-components'
import { SideMenu, SIDE_MENU_ID, SIDE_MENU_WIDTH } from './SideMenu'

export const GuestNarrowHeader: VFC = () => {
  const [isMenuOpen, setMenuOpen] = useState(false)

  useEffect(() => {
    const rootElement = window.document.body
    const headerElement = window.document.getElementsByTagName('header').item(0)
    const sideMenuElement = window.document.getElementById(SIDE_MENU_ID)
    if (isMenuOpen) {
      rootElement.setAttribute(
        'style',
        `margin-left: -${SIDE_MENU_WIDTH};margin-right: ${SIDE_MENU_WIDTH};overflow-x: hidden;`,
      )
      headerElement?.setAttribute(
        'style',
        `margin-left: -${SIDE_MENU_WIDTH};margin-right: ${SIDE_MENU_WIDTH};`,
      )
      sideMenuElement?.setAttribute('style', `right: 0;`)
      return
    }
    rootElement.removeAttribute('style')
    headerElement?.removeAttribute('style')
    sideMenuElement?.removeAttribute('style')
    return () => {
      rootElement.removeAttribute('style')
      headerElement?.removeAttribute('style')
      sideMenuElement?.removeAttribute('style')
    }
  }, [isMenuOpen])

  return (
    <>
      <Header>
        <LogoLink href={TOP}>
          <Logo height="30px" width="100px" />
        </LogoLink>
        <Tel href={`tel:${TEL_CONTACT}`}>
          <img src={PUBLISHED} alt="" />
          {TEL_CONTACT}
        </Tel>
        <MenuButton onClick={() => setMenuOpen(!isMenuOpen)}>
          <MenuIcon />
        </MenuButton>
      </Header>
      <SideMenu />
    </>
  )
}

const Header = styled.div`
  display: flex;
  position: relative;
  justify-content: center;
  align-items: center;
  height: 45px;
  padding: 5px 0;
  background-color: ${truewhite};
  box-shadow: 0px 0px 5px ${trueblack}80;
`
const LogoLink = styled(Link)`
  position: absolute;
  top: 8px;
  left: 15px;
`
const Tel = styled(Link)`
  padding: 8px 3px;
  border-radius: 3px;
  color: ${trueblack};
  border: 1px solid ${_telborder};
  font-weight: ${fontWeightBold};

  @media screen and (max-width: 360px) {
    margin-right: -60px;
  }
`

const MenuButton = styled.button`
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  width: 45px;
  height: 45px;
  background-color: ${orange};
  color: ${white};
  font-size: 13px;
  padding: 10px;

  ${flexCenter};
  svg {
    fill: ${white};
    width: 35px;
    height: 35px;
  }
`
